import React from 'react';
import { useUserPresence } from '../hooks/useUserPresence';

interface OnlineIndicatorProps {
  userId: string | null | undefined;
  className?: string;
}

const OnlineIndicator: React.FC<OnlineIndicatorProps> = ({ userId, className = '' }) => {
  const isOnline = useUserPresence(userId);

  if (!isOnline) return null;

  return (
    <span
      className={`block w-2.5 h-2.5 rounded-full bg-green-500 border-2 border-white dark:border-gray-800 ${className}`}
      aria-label="Online"
    />
  );
};

export default OnlineIndicator;
